import { render, staticRenderFns } from "./fazhan.vue?vue&type=template&id=50598cae&scoped=true&"
import script from "./fazhan.vue?vue&type=script&lang=js&"
export * from "./fazhan.vue?vue&type=script&lang=js&"
import style0 from "./fazhan.vue?vue&type=style&index=0&id=50598cae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50598cae",
  null
  
)

export default component.exports